import { R } from '@/features/profile/resources/ProfileResources.resx';
import { LinkButton, VerticalContainer } from '@/components';
import { Utils } from '@/shared/Utils';

export const OnlinePharmacy = () => {
    return (
        <VerticalContainer spacing="md">
            <h2 id="heading-OnlinePharmacy">{R.OnlinePharmacy}</h2>

            <div
                className="max-w-prose whitespace-pre-wrap"
                dangerouslySetInnerHTML={{
                    __html: Utils.decodeHtml(R.OnlinePharmacyBody1),
                }}
            />

            <h5 className="mt-4">{R.OnlinePharmacyHeader2}</h5>
            <div className="max-w-prose">{R.OnlinePharmacyBody2}</div>
            <LinkButton
                variant="secondary"
                href="https://apopro.dk/partner/hejdoktor"
                target="_blank"
            >
                {R.OnlinePharmacyLink}
            </LinkButton>

            <div className="mt-6 max-w-prose whitespace-pre-line">
                {R.OnlinePharmacyDisclaimer}
            </div>
        </VerticalContainer>
    );
};
